import React, { useEffect } from "react";
import DataTable from "../datatable";
import { useState } from "react";
import { exitStatusConfig, PAGINATION_DEFAULT } from "../../utils/constants";
import { useHistory } from "react-router-dom";
import Button from "../button";
import {
  useDeleteExit,
  useGetTerminations,
  useMarkExitComplete,
} from "../../redux/employees/hook/exit";
import AddEmployeeExit from "../modal/hr-section/employee-exit/add-exit";
import { useGetEmployees } from "../../redux/employees/hook";
import SelectExitOption from "../modal/hr-section/employee-exit/select-exit-option";

const TerminationsTab = () => {
  useEffect(() => {}, []);

  const { data: employees } = useGetEmployees(9, 1, -1, "");
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    satusFilter: PAGINATION_DEFAULT.statusFilter,
    search: "",
  });

  const [exitData, setExitData] = useState(null);
  const [title, setTitle] = useState(null);
  const [buttonText, setButtonText] = useState(null);
  const [showAddExitOptions, setShowAddExitOptions] = useState(null);
  const [showAddExit, setShowAddExit] = useState(null);

  const [tableType, setTableType] = useState("employee-exit");

  const { mutateAsync: deleteExit } = useDeleteExit();

  const { mutateAsync: markExit } = useMarkExitComplete();

  const switchFunction = () => {
    if (tableType === "employee-exit") {
      setTableType("table");
    } else {
      setTableType("employee-exit");
    }
  };

  const { data: terminations } = useGetTerminations(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  );

  const history = useHistory();

  const tableConfig = {
    headers: ["Role", "Job Type", "Location Type", "Application Close"],
    keys: ["role", "job_type", "location_type", "application_end"],
    mobileHeader: {
      left: {
        title: "Role",
        key: "role",
      },
      right: {
        title: "Application Close",
        key: "application_end",
      },
    },
  };

  const actionConfig = [
    {
      name: "View",
      color: "green",
      action: (id) => {
        let index = terminations.data.findIndex((item) => item.id === id);

        history.push("/exit/view/" + terminations.data[index].id);
      },
    },
    {
      name: " Update",
      color: "orange",
      action: (id) => {
        let index = terminations.data.findIndex((item) => item.id === id);
        setTitle("Update Employee Termination");
        setButtonText("Update Termination");
        setExitData(terminations.data[index]);
        setShowAddExit(true);
      },
    },
    {
      name: "Mark As Reviewed",
      color: "green",
      action: async (id) => {
        let index = terminations.data.findIndex((item) => item.id === id);
        await markExit({
          onboarding_id: terminations.data[index].id,
          status: terminations.data[index].status == 1 ? 0 : 1,
        });
      },
    },
    {
      name: " Remove",
      color: "red",
      action: async (id) => {
        let index = terminations.data.findIndex((item) => item.id === id);
        await deleteExit(terminations.data[index].id);
      },
    },
  ];

  return (
    <div className="flex flex-col bg-white rounded">
      {showAddExitOptions ? (
        <SelectExitOption
          isOpen={showAddExitOptions}
          closeModal={() => setShowAddExitOptions(false)}
          type={"termination"}
        />
      ) : null}
      {showAddExit ? (
        <AddEmployeeExit
          isOpen={showAddExit}
          closeModal={() => setShowAddExit(false)}
          type={"termination"}
          exitData={exitData}
          title={title}
          buttonText={buttonText}
        />
      ) : null}

      <div className="flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3">
        <div className="md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full">
          Terminations
        </div>
        <div className="flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full">
          <div className="md:w-fit w-[100%]">
            <Button
              text="New Termination"
              type="button"
              theme="primary"
              className="flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center"
              textClass={"!text-[11px]"}
              leftIcon={"add"}
              disabled={!employees}
              onClick={() => {
                setTitle("Add Employee Termination");
                setButtonText("Save Termination");
                setExitData(null);
                setShowAddExitOptions(true);
              }}
            />
          </div>
        </div>
      </div>
      <hr className="divider mt-2 mb-1" />
      <DataTable
        data={terminations}
        tableConfig={tableConfig}
        statusConfig={exitStatusConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        filterByStatus={true}
        computedActions={true}
        tableType={tableType}
        switchFunction={switchFunction}
        layoutSwitch={true}
        searchData={true}
        noCheck={true}
      />
    </div>
  );
};

export default TerminationsTab;
